import { chatSegments, getItem, type ItemInstance, RARITY_COLORS } from '@shefira/shared';

import { pinItemCard } from './item-hover.js';
import { uiText } from './text.js';

/**
 * Items linked in the chat (ADR 0085): drawn as their name in brackets, in
 * their rarity's colour, and a click opens their card as the sender holds
 * the piece (+N, affixes).
 */

/** `[Épée de bois +3]`: what a link reads, in the input and in the log. */
export function itemLinkLabel(item: ItemInstance): string {
  const name = getItem(item.templateId)?.name ?? item.templateId;
  const level = item.upgradeLevel > 0 ? ` +${String(item.upgradeLevel)}` : '';
  return `[${uiText(name)}${level}]`;
}

/** A line's text with its links, appended to `into`. */
export function appendChatText(
  into: HTMLElement,
  text: string,
  links: readonly ItemInstance[] | undefined,
): void {
  for (const segment of chatSegments(text, links)) {
    if ('text' in segment) {
      into.append(uiText(segment.text));
      continue;
    }
    const item = segment.item;
    const template = getItem(item.templateId);
    const link = document.createElement('span');
    link.className = 'chat__item';
    link.textContent = itemLinkLabel(item);
    if (template !== undefined) {
      link.style.color = `#${RARITY_COLORS[template.rarity].toString(16).padStart(6, '0')}`;
      link.addEventListener('click', () => {
        pinItemCard(template, item, link);
      });
    }
    into.append(link);
  }
}

/**
 * The line as the bubble over the speaker's head says it: the bitmap font
 * has its accents, so the names stay as the data writes them.
 */
export function bubbleText(text: string, links: readonly ItemInstance[] | undefined): string {
  return chatSegments(text, links)
    .map((segment) => {
      if ('text' in segment) return segment.text;
      const { item } = segment;
      const name = getItem(item.templateId)?.name ?? item.templateId;
      return `[${name}${item.upgradeLevel > 0 ? ` +${String(item.upgradeLevel)}` : ''}]`;
    })
    .join('');
}
